import React from 'react';
import { styled } from "@mui/material";

type FigureProps = {
    src: string;
    alt: string;
    caption?: React.ReactNode;
}
export const ImageFigure = ({ src, alt, caption }: FigureProps) => (
    <StyledFigure>
        <img src={src} alt={alt} />
        {caption && <StyledFigcaption>{caption}</StyledFigcaption>}
    </StyledFigure>
);

type VideoProps = {
    src: string;
    caption?: React.ReactNode;
}

export const VideoFigure = ({ src, caption }: VideoProps) => (
    <StyledFigure>
        <video src={src} controls />
        {caption && <StyledFigcaption>{caption}</StyledFigcaption>}
    </StyledFigure>
);


const StyledFigure = styled('figure')({
    margin: '16px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& img, & video': {
        width: '100%',
        height: 'auto',
    },
});

const StyledFigcaption = styled('figcaption')({
    marginTop: 8,
    textAlign: 'center',
    fontStyle: 'italic',
    fontSize: 13,
    color: '#555',
    maxWidth: 720,
});

